const parseUtmLabels = () => {
  let searchStr = window.location?.search || "";
  if (!searchStr) {
    return
  }
  searchStr = searchStr.slice(1);

  let searchObject = {};
  searchStr.split("&").map((str) => {
    const [key, value] = str.split('=');
    searchObject[key] = value;
  });
  if (Object.keys(searchObject).length <= 0) {
    return;
  }

  let utmLabels = {};
  Object.keys(searchObject).map((key) => {
    if (key.indexOf('utm_') > -1) {
      utmLabels[key] = searchObject[key]
    }
  })
  if (Object.keys(utmLabels).length <= 0) {
    return;
  }

  return utmLabels
}

export {
  parseUtmLabels
}
